import { render, staticRenderFns } from "./AdjustUserBalance.vue?vue&type=template&id=07cbb41f&"
import script from "./AdjustUserBalance.vue?vue&type=script&lang=js&"
export * from "./AdjustUserBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports